import CentralMappingMappingEntrySerializer from 'lumen/serializers/central-mapping/mapping-entry';

export default class CentralMappingMappingEntryMarketSegmentSerializer extends CentralMappingMappingEntrySerializer {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  modelNameFromPayloadKey(key: string) {
    if (key === 'data') {
      return super.modelNameFromPayloadKey(
        'central-mapping/mapping-entry-market-segment',
      );
    }

    return key;
  }
}
